import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Table, Spinner, Badge, Button, Modal, Form } from "react-bootstrap";

const MyBooking = () => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [currentAppointment, setCurrentAppointment] = useState(null);
  const [status, setStatus] = useState("");
  const [remark, setRemark] = useState("");
  const [userIsDoctor, setUserIsDoctor] = useState(false); // NEW

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.id;
    const isDoctor = user?.isDoctor === 1;

    setUserIsDoctor(isDoctor); // Store for later

    if (userId) {
      if (isDoctor) {
        fetchDoctorAppointments(userId);
      } else {
        fetchUserAppointments(userId);
      }
    } else {
      Swal.fire("Error", "User not found. Please log in again.", "error");
      setLoading(false);
    }
  }, []);

  const fetchUserAppointments = async (userId) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/appointments/user/${userId}`
      );
      setAppointments(res.data.appointments);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchDoctorAppointments = async (doctorId) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/appointments/doctor/${doctorId}`
      );
      setAppointments(res.data.appointments);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (appointmentId) => {
    try {
     await axios.put(
        `${process.env.REACT_APP_API_URL}/appointment/${appointmentId}`,
        { status, remark }
      );

      setAppointments((prevAppointments) =>
        prevAppointments.map((appointment) =>
          appointment.id === appointmentId
            ? { ...appointment, status, remark }
            : appointment
        )
      );

      setShowModal(false);
      Swal.fire("Success", "Appointment updated successfully.", "success");
    } catch (err) {
      console.log(err);
      Swal.fire("Error", "Failed to update the appointment.", "error");
    }
  };

  const getStatusBadge = (status) => {
    switch (status.toLowerCase()) {
      case "pending":
        return <Badge bg="info">Pending</Badge>;
      case "confirmed":
        return <Badge bg="success">Confirmed</Badge>;
      case "cancelled":
        return <Badge bg="danger">Cancelled</Badge>;
      default:
        return <Badge bg="secondary">{status}</Badge>;
    }
  };

  const openModal = (appointment) => {
    setCurrentAppointment(appointment);
    setStatus(appointment.status);
    setRemark(appointment.remark || "");
    setShowModal(true);
  };

  return (
    <div
      className="mt-5 p-5"
      style={{
        minHeight: "85vh",
        backgroundColor: "aliceblue",
        width: "100%",
        margin: "auto",
      }}
    >
      <h3 className="text-primary text-center mb-4">My Bookings</h3>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Table bordered hover responsive className="text-center shadow rounded">
          <thead className="table-primary">
            <tr>
              <th>#</th>
              <th>{userIsDoctor ? "User Name" : "Doctor Name"}</th>
              <th>Appointment Date</th>
              <th>Appointment Time</th>
              <th>Address</th>
              <th>Charges</th>
              <th>Status</th>
              <th>Remark</th>
              {userIsDoctor && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {appointments.length > 0 ? (
              appointments.map((appointment, index) => (
                <tr key={appointment.id}>
                  <td>{index + 1}</td>
                  <td>
                    {userIsDoctor
                      ? appointment.user_name
                      : appointment.doctor_name}
                  </td>
                  <td>
                    {new Date(appointment.appointment_date).toLocaleDateString(
                      "en-GB"
                    )}
                  </td>
                  <td>{appointment.appointment_time}</td>
                  <td>{appointment.address}</td>
                  <td>₹{appointment.charge}</td>
                  <td>{getStatusBadge(appointment.status)}</td>
                  {userIsDoctor ? (
                    <td>{appointment.remark || "—"}</td>
                  ) : (
                    <td>{appointment.remark2 || "—"}</td>
                  )}
                  {userIsDoctor && (
                    <td>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => openModal(appointment)}
                        className="fw-bold"
                      >
                        Update
                      </Button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No appointments found.</td>
              </tr>
            )}
          </tbody>
        </Table>
      )}

      {/* Modal for status and remark update */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="mt-5"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Appointment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Status</Form.Label>
              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">Select status</option>
                <option value="Pending">Pending</option>
                <option value="Confirmed">Confirmed</option>
                <option value="Cancelled">Cancelled</option>
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label className="fw-bold">Remark</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => handleStatusChange(currentAppointment.id)}
            className="fw-bold"
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MyBooking;
